'use strict';

import BaseService from './base.service';

class OperationTasksService extends BaseService {
  static $inject = ['OperationProcedureTask', 'SegaUser'];
  Model: any;
  constructor(OperationProcedureTask, SegaUser) {
    super(OperationProcedureTask, SegaUser);
  }
}

export default OperationTasksService;
